export const GET_CASE_HISTORY_REQUEST = "ALL_CASES/GET_CASE_HISTORY_REQUEST";
export const GET_CASE_HISTORY_SUCCESS = "ALL_CASES/GET_CASE_HISTORY_SUCCESS";
export const GET_CASE_HISTORY_FAILURE = "ALL_CASES/GET_CASE_HISTORY_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/History/constants.js